import React from "react";
import styles from "./EntityGrid.module.scss";

/**
 * EntityCard repeater — view mode'a göre kolon sayısı değişir.
 *
 *   <EntityGrid mode="grid-3">
 *     {items.map(it => <EntityCard key={it.id} ... />)}
 *   </EntityGrid>
 *
 * Mode → kolon:
 *   list-1 → 1 (full-width)
 *   list-2 → 2
 *   grid-3 → 3
 *   grid-4 → 4
 *
 * Mobil (xs): tüm modlar 1 kolon (touch ergonomics).
 * Tablet (sm-md): list-1→1, list-2→2, grid-3→2, grid-4→2-3
 * Desktop: tam mod.
 */
const EntityGrid = ({ mode = "grid-3", children, emptyState }) => {
  const isEmpty = !children || (Array.isArray(children) && children.length === 0);

  if (isEmpty && emptyState) return <div className={styles.empty}>{emptyState}</div>;

  return (
    <div className={styles.grid} data-mode={mode}>
      {children}
    </div>
  );
};

export default EntityGrid;
